// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3N3LY","buttons":"Footer_buttons__8oL9B"};